module.exports = __webpack_public_path__ + "static/media/honeycomb-bee.cc06b597.png";